import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { BlockedUserPlaceholderXl, BlockedUserPlaceholderL, BlockedUserPlaceholderM, BlockedUserPlaceholderS, BlockedUserPlaceholderXs } from '@moim/icons';
import { ImageStyle } from './styledComponents.mjs';

var BlockedUserXL = styled(BlockedUserPlaceholderXl).withConfig({
  displayName: "BlockedUserXL",
  componentId: "sc-hf59r7-0"
})(["", ""], ImageStyle);
var BlockedUserL = styled(BlockedUserPlaceholderL).withConfig({
  displayName: "BlockedUserL",
  componentId: "sc-hf59r7-1"
})(["", ""], ImageStyle);
var BlockedUserM = styled(BlockedUserPlaceholderM).withConfig({
  displayName: "BlockedUserM",
  componentId: "sc-hf59r7-2"
})(["", ""], ImageStyle);
var BlockedUserS = styled(BlockedUserPlaceholderS).withConfig({
  displayName: "BlockedUserS",
  componentId: "sc-hf59r7-3"
})(["", ""], ImageStyle);
var BlockedUserXS = styled(BlockedUserPlaceholderXs).withConfig({
  displayName: "BlockedUserXS",
  componentId: "sc-hf59r7-4"
})(["", ""], ImageStyle);
var BlackedUserPlaceholder = function BlackedUserPlaceholder(_ref) {
  var size = _ref.size,
    elementPaletteProps = _ref.elementPaletteProps;
  switch (size) {
    case "xl":
      return jsx(BlockedUserXL, {
        elementPaletteProps: elementPaletteProps
      });
    case "l":
      return jsx(BlockedUserL, {
        elementPaletteProps: elementPaletteProps
      });
    case "m":
      return jsx(BlockedUserM, {
        elementPaletteProps: elementPaletteProps
      });
    case "s":
      return jsx(BlockedUserS, {
        elementPaletteProps: elementPaletteProps
      });
    case "xs":
      return jsx(BlockedUserXS, {
        elementPaletteProps: elementPaletteProps
      });
    default:
      return null;
  }
};

export { BlackedUserPlaceholder, BlockedUserL, BlockedUserM, BlockedUserS, BlockedUserXL, BlockedUserXS };
